import { LoadingSpinner } from "@/components/ui/LoadingSpinner/LoadingSpinner";
import { getFirmProfilePictureOptions } from "@/lib/data/react-query";
import { cn } from "@/lib/utils/cn";
import { useQuery } from "@tanstack/react-query";
import { LawWorksLogo } from "../LawWorksLogo/LawWorksLogo";

type FirmProfilePhotoProps = {
  firmName?: string;
  firmProfilePicturePresignedUrlKey?: string;
  className?: string;
  logoClassName?: string;
  showFallbackLogo?: boolean;
};

export const FirmProfilePhoto = ({
  firmName,
  firmProfilePicturePresignedUrlKey,
  className,
  logoClassName,
  showFallbackLogo = true,
}: FirmProfilePhotoProps) => {
  const { data: firmProfilePicture, isLoading } = useQuery(
    getFirmProfilePictureOptions(firmProfilePicturePresignedUrlKey),
  );

  const hasProfilePicture = Boolean(firmProfilePicturePresignedUrlKey);

  return (
    <div className={cn("flex justify-center overflow-hidden", className)}>
      {hasProfilePicture ? (
        isLoading ? (
          <LoadingSpinner />
        ) : (
          <img
            className="h-[100px] w-[270px] object-contain"
            src={firmProfilePicture?.url}
            alt={`${firmName ?? "Firm"} logo`}
            loading="eager"
          />
        )
      ) : showFallbackLogo ? (
        <LawWorksLogo
          className={cn("max-h-full max-w-full", logoClassName)}
          variant="black"
        />
      ) : null}
    </div>
  );
};
